import { useEffect, useState } from "react";
import type DeviceTemplate from "../../models/DeviceTemplate";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";

/** Mounted only for open menu entries; catalog images may need loading first. */
export function TemplateFrontImage({ template }: { template: DeviceTemplate }) {
  useOnChangeWatcher(template);
  const [, redraw] = useState(0);
  const [failedSource, setFailedSource] = useState<string>();
  const source = template.getFrontImage(undefined);

  useEffect(() => {
    if (source) return;
    let active = true;
    void template.knxProductData.loadFrontImage().then(() => {
      if (active) redraw(value => value + 1);
    }).catch(() => { /* Keep the reserved image space when no image is available. */ });
    return () => { active = false; };
  }, [template, source]);

  return <span style={{ display: "inline-flex", width: 48, height: 48, flexShrink: 0 }}>
    {source && source !== failedSource && <img src={source} alt="" loading="lazy"
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
      onError={() => setFailedSource(source)} />}
  </span>;
}
